import arrowUp from "static/icons/icon-arrow-up.svg"
import arrowDown from "static/icons/icon-arrow-down.svg"

const toggleClass = (el, settings) => {
  if (!el) return null

  if (settings.opened) return el.classList.remove("is-truncated")

  return el.classList.add("is-truncated")
}

const toggleCaret = (e, settings) => {
  if (!e) return null

  if (settings.opened) {
    e.src = arrowUp
    return e
  }

  e.src = arrowDown
  return e
}

const toggleLabel = (el, settings) => {
  const label = el.querySelector("[data-read-more-label]")
  if (!label) return null

  label.textContent = settings.opened
    ? el.dataset.openedLabel || "Read less"
    : el.dataset.closedLabel || "Read more"

  return label
}

const persistCookie = (el, settings) => {
  if (!el.dataset.cookieName) return null

  const expires = new Date()
  expires.setFullYear(expires.getFullYear() + 1)

  const value = settings.opened
    ? el.dataset.cookieOpenedValue || "1"
    : el.dataset.cookieClosedValue || "0"
  const cookieValue = `${encodeURIComponent(el.dataset.cookieName)}=${encodeURIComponent(value)}`
  const cookieExpires = `expires=${expires.toUTCString()}`

  document.cookie = [cookieValue, cookieExpires, "path=/", "SameSite=Lax"].join("; ")

  return value
}

const click = (ct, settings) => {
  let opened = settings.opened || false

  return function f(e) {
    e.preventDefault()

    opened = !opened

    requestAnimationFrame(() => {
      toggleClass(ct, { opened })
      toggleCaret(this.querySelector("[data-read-more-caret]"), { opened })
      toggleLabel(this, { opened })
      this.dataset.opened = opened
      persistCookie(this, { opened })
    })
  }
}

export default function readMore(el) {
  if (!el) return null

  const content = document.querySelector(el.dataset.for)
  const opened = el.dataset.opened || content?.dataset.opened || "false"

  return el.addEventListener("click", click(content, { opened: opened === "true" }))
}
